import Users from './AdminUsersPage';
import Clients from './AdminClientsPage';
import CreateUser from 'src/components/admin/sections/AdminCreateUserPage';
import Offices from './AdminOfficesPage';

export default {
    Users,
    Clients,
    CreateUser,
    Offices,
};



// WEBPACK FOOTER //
// ./src/components/admin/sections/index.ts